import React, { Component } from 'react'
import { Projects } from '../../schema/types.d'
import ProjectsList from './ProjectsList'

interface ProjectFilterState {
  searchText: string
  filterProjectsText: string
}
class ProjectFilter extends Component<Projects.Props, ProjectFilterState> {
  constructor(props: Projects.Props) {
    super(props)
    this.state = {
      searchText: null,
      filterProjectsText: null
    }
    this.changeSearch = this.changeSearch.bind(this)
    this.selectProject = this.selectProject.bind(this)
  }

  changeSearch(event) {
    const key = event.key
    const searchString: string = event.target.value
    if (key === 'Enter' || searchString.length == 3) {
      this.setState({
        searchText: searchString
      })
      if (key === 'Enter')
        this.setState({
          filterProjectsText: searchString.split(':')[0]
        })
    }
  }

  selectProject(event) {
    const projectString: string = event.target.value
    const projectNo = projectString.split(':')[0]
    this.setState({
      searchText: projectNo,
      filterProjectsText: projectNo
    })
  }

  render() {
    return (
      <div>
        <div className="bg-white pa3 ph5-ns">
          <div className="di pl4">
            <label htmlFor="filter_string" className="f6 b black-60 pr2">
              Projects
            </label>
            <input
              ref="filter_string"
              className="w-100 input-reset ba b--black-20 pa2 mb2"
              type="text"
              onKeyUp={this.changeSearch}
              placeholder="Seach by name or number.."
              list="project_suggestions"
            />
            {this.state.searchText ? (
              <Projects.Component
                variables={{ searchFor: this.state.searchText }}
              >
                {({ loading, error, data }) => {
                  if (loading) return ''
                  if (error) return <div>Error</div>
                  if (!data) return <div>No data!</div>
                  const projects = data.projects
                  return (
                    <datalist id="project_suggestions">
                      {projects.map(p => (
                        <option key={p.id}>
                          {p.projectNumber}: {p.name}
                        </option>
                      ))}
                    </datalist>
                  )
                }}
              </Projects.Component>
            ) : (
              ''
            )}
          </div>
        </div>
        <ProjectsList searchText={this.state.filterProjectsText} />
      </div>
    )
  }
}

export default ProjectFilter
